import { Injectable } from '@angular/core';
import { OrderLanguageEnum } from 'src/generated/graphql';

const MMA = 1153;
const GPM = 0.2;
const PSD = 0.0698;
const VSD = 0.1252;

const FULL_NPD_LT = 747;
const COEF_LOW_SALARY_LT = 0.49;

@Injectable({
  providedIn: 'root'
})
export class SalaryCalculatorService {

  static countryISO = '';



  private MAX_NETTO_WITH_NPD = this.getMonthlyNetto((400 / 0.18) + MMA);

  constructor() { }


  getNPD(monthlyIncome) {
    return 400 - 0.18 * (monthlyIncome - MMA);
  }

  /** Netto from Brutto */
  getMonthlyNetto(monthlyBrutto) {
    // return monthlyBrutto - (monthlyBrutto - this.getNPD(monthlyBrutto)) * GPM - monthlyBrutto * (PSD + VSD);
    // NOTE: 0.18 and 400 from forumla in NPD
    let brutto = 0;
    switch (SalaryCalculatorService.countryISO) {
      case 'lt':
        brutto = this.getMonthlyNettoForLT(monthlyBrutto);
        break;

      case 'lv':
        brutto = this.getMonthlyNettoForLV(monthlyBrutto);
        break;

      case 'ee':
        brutto = this.getMonthlyNettoForEE(monthlyBrutto);
        break;

      default:
        brutto = this.getMonthlyNettoForLT(monthlyBrutto);
        break;
    }
    return brutto;
  }

  getMonthlyNettoForLT(monthlyBrutto) {
    const taxableForGpm = Math.max(0, monthlyBrutto - this.getNPDLT(monthlyBrutto));
    return monthlyBrutto - taxableForGpm * GPM - monthlyBrutto * (PSD + VSD);
  }

  getMonthlyNettoForLV(monthlyBrutto) {
    return monthlyBrutto - (monthlyBrutto * 10.5 / 100) - ((monthlyBrutto - (monthlyBrutto * 10.5 / 100)) * 20 / 100);
  }

  getMonthlyNettoForEE(monthlyBrutto) {
    if (monthlyBrutto <= 1200) {
      return monthlyBrutto - ((monthlyBrutto - 500) * 20 / 100) - (monthlyBrutto * 1.6 / 100);
    } else if (monthlyBrutto >= 1201 && monthlyBrutto <= 2099) {
      return monthlyBrutto - ((monthlyBrutto - (500 - 0.55556 * (monthlyBrutto - 1200))) * 20 / 100) - (monthlyBrutto * 1.6 / 100);
    } else {
      return monthlyBrutto - (monthlyBrutto * 20 / 100) - (monthlyBrutto * 1.6 / 100);
    }
  }

  /** Netto from Brutto ends here */



  /** Brutto from Netto */
  getMonthlyBruttoFromNetto(monthlyNetto) {

    let netto = 0;

    switch (SalaryCalculatorService.countryISO) {
      case 'lt':
        netto = this.getMonthlyBruttoFromNettoForLT(monthlyNetto);
        break;

      case 'lv':
        netto = this.getMonthlyBruttoFromNettoForLV(monthlyNetto);
        break;

      case 'ee':
        netto = this.getMonthlyBruttoFromNettoForEE(monthlyNetto);
        break;

      default:
        netto = this.getMonthlyBruttoFromNettoForLT(monthlyNetto);
        break;
    }
    return netto;
  }

  getMonthlyBruttoFromNettoForLT(monthlyNetto) {
    const socialRate = PSD + VSD;
    const npdIntercept = FULL_NPD_LT + COEF_LOW_SALARY_LT * MMA;
    const bruttoThresholdNoGpm = npdIntercept / (1 + COEF_LOW_SALARY_LT);
    const bruttoThresholdNoNpd = npdIntercept / COEF_LOW_SALARY_LT;
    const nettoThresholdNoGpm = bruttoThresholdNoGpm * (1 - socialRate);
    const nettoThresholdNoNpd = bruttoThresholdNoNpd * (1 - socialRate - GPM);

    if (monthlyNetto <= nettoThresholdNoGpm) {
      return monthlyNetto / (1 - socialRate);
    } else if (monthlyNetto <= nettoThresholdNoNpd) {
      return (monthlyNetto - GPM * npdIntercept) / (1 - socialRate - GPM * (1 + COEF_LOW_SALARY_LT));
    } else {
      return monthlyNetto / (1 - socialRate - GPM);
    }
  }

  getMonthlyBruttoFromNettoForLV(monthlyNetto) {
    return monthlyNetto / (1 - 0.105 - 0.179);
  }

  getMonthlyBruttoFromNettoForEE(monthlyNetto) {
    if (monthlyNetto <= 1200) {
      return (monthlyNetto - 100) / (1-0.016-0.2);
    } else if(monthlyNetto >= 1201 && monthlyNetto <= 2099) {
      return (monthlyNetto - 233.3344) / (1 - (1.55556 * 0.2) - 0.016);
    } else {
      return monthlyNetto / (1 - 0.016 - 0.2);
    }
  }

  /** Brutto from Netto ends here */
  private getNPDLT(monthlyBrutto) {
    return Math.max(FULL_NPD_LT - COEF_LOW_SALARY_LT * (monthlyBrutto - MMA), 0);
  }
}
